import { Toastify } from '.';

export type ApiError = {
  code: string;
  name: string;
  message: string;
};

const MESSAGES = {
  invalidEmail: 'Email is invalid',
  invalidPhone: 'Phone number is invalid',
  unknown: 'An error has occurred',
  required: 'Field cannot be blank',
  accountNotExist: 'Username does not exist',
  incorrectAccount: 'Incorrect username or password',
  incorrectPassword: 'Incorrect password.',
};

const handler = (error: ApiError) => {
  console.error(error);
  Toastify.error(error?.message || MESSAGES.unknown);
};

export default {
  handler,
  MESSAGES,
};
